module.exports = __webpack_public_path__ + "rate.svg";